<template>
  <div id="app">
    <v-app>
    <router-view/>
    <loading-modal :active="loadingModalActive" :canClose="false"/>
    <errors-modal
      :content="errors.content"
    />
  </v-app>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import store from '@/store'
import LoadingModal from '@/components/LoadingModal'
import ErrorsModal from '@/components/ErrorsModal'

export default {
  components: {
    LoadingModal,
    ErrorsModal
  },

  computed: {
    ...mapGetters({
      loadingModalActive: 'root/loadingModalActive',
      errors: 'root/getErrors'
    })
  },
}
</script>

<style lang="stylus">
  @import './stylus/main'
</style>
